module.exports = __webpack_public_path__ + "img/allowDevicesImg.cabd2153.jpg";